import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/x_math_logo.png";
import syltixLogo from "./assets/syltix.png";

const Footer = () => {
  return (
    <footer
      className="text-white pt-12 pb-6 border-t"
      style={{ background: "#0b1220", borderColor: "rgba(148, 163, 184, 0.18)" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:items-center">
          <div className="space-y-4 text-center md:text-left">
            <div className="flex justify-center md:justify-start">
              <img
                src={logo}
                alt="X-Maths logo"
                className="h-10 sm:h-12 w-auto max-w-[10.5rem] brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 max-w-md mx-auto md:mx-0 text-sm sm:text-base">
              Empowering students with next-generation mathematical education through innovative learning solutions.
            </p>
          </div>

          <div className="flex justify-center md:justify-end">
            <div className="space-y-3 text-center md:text-left w-full md:w-auto">
              <h3 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-sky-300">
                Quick Links
              </h3>
              <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:block md:space-y-2">
                {[
                  { label: "Home", path: "/" },
                  { label: "About", path: "/about" },
                  { label: "Inside", path: "/inside" },
                  { label: "Login", path: "/login" },
                  { label: "Sign Up", path: "/signup" },
                ].map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="inline-flex min-h-11 items-center text-gray-400 hover:text-white transition duration-300 md:hover:pl-2"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t mt-8 pt-6" style={{ borderColor: "rgba(148, 163, 184, 0.18)" }}>
          <div className="flex flex-col items-center gap-3 text-center px-2">
            <p className="text-gray-400 text-sm leading-relaxed">
              © {new Date().getFullYear()} X-Maths. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2">
              <p className="text-gray-500 text-xs font-mono">Powered by</p>
              <a 
                href="https://syltix.dev" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 hover:opacity-80 transition-opacity"
              >
                <img 
                  src={syltixLogo} 
                  alt="SYLTIX" 
                  className="h-5 w-auto"
                  style={{ filter: 'invert(1) brightness(2)' }}
                />
                <span className="text-sm text-gray-300 font-semibold">Syltix</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;